import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getSurfaceBorder, getSurfaceColor, getThemeTokens } from '../tokens';

export const styledMuiChip = (theme: Theme): BackstageOverrides['MuiChip'] => {
  const tokens = getThemeTokens(theme);

  return {
    root: {
      backgroundColor: getSurfaceColor(theme, 'subtle'),
      borderRadius: 999,
      border: '1px solid',
      borderColor: getSurfaceBorder(theme),
      color: tokens.textPrimary,
      fontWeight: 600,
      marginBottom: theme.spacing(0.5),
      maxWidth: '100%',
      transition:
        'background-color 150ms ease, border-color 150ms ease, color 150ms ease',
      '& [class*="MuiChip-icon"]': {
        marginLeft: `${theme.spacing(1)} !important`,
      },
      '& [class*="MuiChip-avatar"]': {
        marginLeft: `${theme.spacing(0.5)} !important`,
      },
      '& + &': {
        marginLeft: theme.spacing(0.5),
      },
      '&:hover': {
        backgroundColor: getSurfaceColor(theme, 'accent'),
        borderColor: getSurfaceBorder(theme, 'strong'),
        '& svg': {
          color: tokens.textPrimary,
        },
      },
    },
    deleteIcon: {
      color: tokens.textMuted,
      transition: 'color 150ms ease',
    },
    label: {
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  };
};
